// src/lib/catalogConfig.js
// ───────────────────────────────────────────────────────────────────────────
// 🔒 Candado anti-regresión del catálogo de materiales (PLAN-CATALOGO-MATERIALES
//     Slice 5 · pre-step). Mientras se migran los 43 materiales a la estructura de
//     6 familias, el form VIEJO (MaterialModal: alta/edición/borrado) queda
//     deshabilitado para que nadie re-ensucie el catálogo entre la migración y el
//     form nuevo (Slice 4). Se quita poniendo esto en `false` (o al llegar Slice 4).
// ───────────────────────────────────────────────────────────────────────────
// Slice 4 (alta/edición por CF + UI nueva) cerrado → candado retirado.
export const CATALOG_MIGRATION_LOCK = false;
